import { FC } from 'react';
import { DividerStyled } from './style';

const Divider: FC = ({ children, ...restProps }) => <DividerStyled {...restProps}>{children}</DividerStyled>;

export default Divider;
